import React from "react"
import CustomerDetails from "../../components/Customers/CustomerDetails"

function CustomerDetailPage() {
  return <CustomerDetails />
}

export default CustomerDetailPage
